import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetWarehouseLocationSelector({
  value,
  displayValue,
  warehouse_locations,
  onChange,
  reloadDropdownData,
  viewOnly,
  disabled = false,
  size,
  showCloudIcon = true,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        disabled={disabled}
        selectedValue={value}
        displayValue={displayValue}
        options={warehouse_locations}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Location"
        showCloudIcon={showCloudIcon}
        size={size}
      />
    </React.Fragment>
  )
}
